module.exports = __webpack_public_path__ + "92a7f808b17b8e6f0e5051ce00c80d26.jpg";


//////////////////
// WEBPACK FOOTER
// ./resources/images/lego.jpg
// module id = 267
// module chunks = 1